import React from 'react';
import Footer from '../Footer/Footer';
import Home from '../Home/Home';
import Services from '../Services/Services';

const Header = () => {
  return <div>

    <Home/>
    <Services/>
    <Footer/>
  </div>;
};

export default Header;
